import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Template from './icon-template.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Template {...validProps} />;
}
SvgComponent.iconName = 'iconTemplate';

/**
 * @deprecated This is a legacy icon
 */
export const TemplateIcon = svgIconWrapper(SvgComponent);
